import {
  CURRENT_CHAMBER_UPDATE
} from "../lib/types";


export const updateCurrentSelectedChamber = ( values ) => dispatch => {
  dispatch({
    type: CURRENT_CHAMBER_UPDATE,
    payload: values
  });
};




// WEBPACK FOOTER //
// ./src/actions/current-selected-chamber-actions.js